import React, { useEffect, useRef, useState } from 'react';
import { Typography, Pill } from '@one-thd/sui-atomic-components';
import { useDrawer } from '../DrawerProvider';

const SCROLL_IDLE_MS = 700;

export const FloatingDatePill = () => {
  const { scrollEl } = useDrawer();
  const [isScrolling, setIsScrolling] = useState(false);
  const [currentDate, setCurrentDate] = useState('');
  const idleTimer = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollEl?.current;
    if (!scrollContainer) return undefined;

    const updateCurrentDate = () => {
      const dividers = scrollContainer.querySelectorAll('[data-chat-date]');
      const containerTop = scrollContainer.getBoundingClientRect().top;
      let latestPassed = '';
      dividers.forEach((divider) => {
        if (divider.getBoundingClientRect().bottom <= containerTop) {
          latestPassed = divider.getAttribute('data-chat-date') || '';
        }
      });
      setCurrentDate(latestPassed);
    };

    const handleScroll = () => {
      setIsScrolling(true);
      updateCurrentDate();
      if (idleTimer.current) clearTimeout(idleTimer.current);
      idleTimer.current = setTimeout(() => setIsScrolling(false), SCROLL_IDLE_MS);
    };

    scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
      if (idleTimer.current) clearTimeout(idleTimer.current);
    };
  }, [scrollEl]);

  const isVisible = isScrolling && !!currentDate;

  if (!currentDate) return null;

  return (
    <>
      <div
        className="sui-sticky sui-top-0 sui-z-max sui-flex sui-justify-center sui-pointer-events-none"
        style={{ opacity: isVisible ? 1 : 0, transition: 'opacity 0.2s ease-out' }}
      >
        <div className="sui-bg-primary sui-rounded-full sui-px-3 sui-py-1 sui-shadow-md">
          <Typography variant="body-xs" color="medium">{currentDate}</Typography>
        </div>
      </div>
    </>
  );
};

FloatingDatePill.propTypes = {};
